export default "__VITE_ASSET__c42f02b4__"